import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import QuestionType from "./QuestionType";
import Input from "reactstrap/lib/Input";
import FormGroup from "reactstrap/lib/FormGroup";
import { FaCheck } from 'react-icons/fa';
import Rating from "react-rating";
import Handlebars from "handlebars";



class QuestionHtml extends QuestionType {
    constructor(props) {
        super(props);
        this.state = {
            onlyDialog: false,
            dialogOpen: true
        };
        this.htmlRef = React.createRef();
    }

    getValueAsInt() {
        try {
            return parseInt(this.getValue());
        }
        catch(e) {
            return 0;
        }
    }

    getVorauswahlasInt() {
        try {
            return parseInt(this.getVorauswahl());
        }
        catch(e) {
            return 0;
        }
    }

    componentDidMount() {
        if (this.question()["script"]) {
            window.eval(this.question()["script"]);
        }
        this.adoptDialogs();
    }

    componentDidUpdate() {
        // Aendert sich der Handlebars-Text, setzt React das innerHTML neu - dann
        // sind Klassen und Schliesskreuz weg und der Kasten waere wieder ein
        // Sperr-Popup. Deshalb nach jedem Durchlauf nachziehen; die Methode
        // aendert nur, was noch nicht sitzt.
        this.adoptDialogs();
    }

    /**
     * Die Redaktion baut Hinweise als .popup mit .popup-overlay davor. Das
     * sperrt die ganze Seite, obwohl es nur um eine Frage geht, und es steht
     * nach jedem Neuladen wieder da.
     *
     * Hier wird daraus ein Hinweis an genau der Stelle, an der die Redaktion
     * ihn eingebaut hat: die Sperrflaeche bleibt aus, der Kasten sitzt in der
     * Fragenspalte statt ueber dem Bildschirm und bekommt ein Schliesskreuz.
     * Weil er nichts mehr blockiert, darf er jedes Mal aufgehen, wenn die
     * Frage erscheint - auch nach dem Neuladen.
     *
     * Die Knoten bleiben, wo sie sind, und werden nur umetikettiert:
     * showPopup() und hidePopup() aus dem CMS suchen sie ueber ihre id und
     * funktionieren dadurch weiter.
     */
    adoptDialogs() {
        try {
            const root = this.htmlRef.current;
            if (!root) {
                return;
            }
            const popups = Array.prototype.slice.call(root.querySelectorAll(".popup"));
            const overlays = Array.prototype.slice.call(root.querySelectorAll(".popup-overlay"));
            if (popups.length === 0) {
                return;
            }

            for (const overlay of overlays) {
                overlay.classList.add("wc-info-overlay");
            }

            for (const popup of popups) {
                const isNew = !popup.classList.contains("wc-info-dialog");
                popup.classList.add("wc-info-dialog");
                this.addCloseButton(popup);
                if (isNew) {
                    popup.style.display = "block";
                }
            }

            // Was uebrig bleibt, ist meist nur noch das <style> der Redaktion.
            // Dann soll die Frage keine leere Karte hinterlassen. textContent
            // taugt dafuer nicht - der CSS-Text im <style> zaehlt dort mit.
            // setState nur bei echter Aenderung - sonst dreht sich
            // componentDidUpdate im Kreis.
            if (this.hasNoVisibleContent(root)) {
                if (!this.state.onlyDialog) {
                    this.setState({onlyDialog: true, dialogOpen: true});
                }
            }
        }
        catch(ignoreError) {}
    }

    /**
     * Steht in der Frage ausser dem Hinweis noch etwas? textContent taugt dafuer
     * nicht - der CSS-Text im <style> zaehlt dort mit. Der Hinweis selbst und
     * die stillgelegte Sperrflaeche zaehlen ebenfalls nicht.
     */
    hasNoVisibleContent(root) {
        const rest = Array.prototype.slice.call(root.childNodes).filter((node) => {
            if (node.nodeType === 3) {
                return node.textContent.trim().length > 0;
            }
            if (node.nodeType !== 1) {
                return false;
            }
            if (node.tagName === "STYLE" || node.tagName === "SCRIPT") {
                return false;
            }
            if (node.classList && (node.classList.contains("wc-info-dialog") ||
                node.classList.contains("wc-info-overlay"))) {
                return false;
            }
            return true;
        });
        return rest.length === 0;
    }

    addCloseButton(popup) {
        if (popup.querySelector(".wc-info-dialog-close")) {
            return;
        }
        const close = document.createElement("button");
        close.className = "wc-info-dialog-close";
        close.setAttribute("type", "button");
        close.setAttribute("aria-label", "Hinweis schliessen");
        close.innerHTML = "&times;";
        close.onclick = () => this.closeDialog(popup);
        popup.insertBefore(close, popup.firstChild);
    }

    closeDialog(popup) {
        popup.classList.add("is-closing");
        setTimeout(() => {
            popup.classList.remove("is-closing");
            popup.style.display = "none";
            // Ohne den Hinweis bliebe sonst eine leere Karte stehen.
            this.setState({dialogOpen: false});
        }, 220);
    }

    getParsedHtml() {
        const data = this.question()["html"];
        try {
            var template = Handlebars.compile(data ? data : '');
            const d = template(Object.assign({}, this.qCtrl().formular.state.website,{
                zoho: this.qCtrl().getZohoCustomerData(),

            }));
            return d;
        }
        catch(e) {

        }
        return data;
    }

    render() {
        const html = this.getParsedHtml();
        // Leeres HTML soll keine leere Karte erzeugen.
        if (!html || html.toString().trim().length === 0) {
            return null;
        }

        return <Container fluid={true}
                          className={"ranking-container "
                            + (this.state.onlyDialog ? "wc-html-dialog-only " : "")
                            + (this.state.onlyDialog && !this.state.dialogOpen ? "is-hidden " : "")
                            + (this.hasError() ? "error" : "")}>
            <Row>
                <Col className={"p-1"} md={12}>
                    <span ref={this.htmlRef} dangerouslySetInnerHTML={{ __html: html }}></span>

                </Col>
            </Row>
        </Container>;
    }
};

QuestionHtml.propTypes = {

};


export default QuestionHtml;
